module.exports = __webpack_public_path__ + "img/audit-icon.12c9d589.svg";